/**
 * The PageInnerWrapper function is a React component that wraps its children in a div with specific
 * styling classes.
 * @returns A functional component named PageInnerWrapper is being returned. It contains a div element
 * with the class names "white_shd full margin_bottom_30 padding_infor_info full inner_elements" and
 * renders the children components passed to it.
 */
const PageInnerWrapper = ({ children }) => {
  return (
    <div className="white_shd full margin_bottom_30 padding_infor_info full inner_elements">
      {children}
    </div>
  );
};

export default PageInnerWrapper;
